import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './inquiry-custom-order.css'

import React, { useState, useEffect } from 'react'


const InquiryCustomOrder = (props) => {
  const [showSuccess, setShowSuccess] = useState(false)

  useEffect(() => {
    // Check if we're on the thank you page or have submitted parameter
    const urlParams = new URLSearchParams(window.location.search)
    const isThankYou = window.location.pathname.includes('thankyou') || urlParams.get('submitted') === 'true'
    
    if (isThankYou) {
      setShowSuccess(true)
      
      // Auto-hide after 5 seconds
      const timer = setTimeout(() => {
        setShowSuccess(false)
        // Clean URL
        window.history.replaceState({}, document.title, window.location.pathname)
      }, 5000)
      
      return () => clearTimeout(timer)
    }
  }, [])

  return (
    <div className="inquiry-custom-order-container1">
      <Helmet>
        <title>Inquiry-Custom-Order - Nature Ready</title>
        <meta
          property="og:title"
          content="Inquiry-Custom-Order - Nature Ready"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="inquiry-custom-order-container2">
        <div className="inquiry-custom-order-container3">
          <Script
            html={`<style>
        @keyframes fadeInUp {from {opacity: 0;
transform: translateY(30px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="inquiry-custom-order-container4">
        <div className="inquiry-custom-order-container5">
          <Script
            html={`<style>
600;700&family=Inter:wght@400;500;600;700&display=swap");

  :root {
  --font-family-heading: "Playfair Display", serif;
  --font-family-body: "Inter", sans-serif;
}
@media (prefers-reduced-motion: reduce) {
*, *::before, *::after {
  animation-duration: 0.01ms !important;
  animation-iteration-count: 1 !important;
  transition-duration: 0.01ms !important;
}
}
input:focus, textarea:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}
::selection {
  background: color-mix(in srgb, var(--color-primary) 20%, transparent);
  color: var(--color-on-surface);
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="inquiry-custom-order-container6">
        <div className="inquiry-custom-order-container7">
          <Script
            html={`<script defer data-name="inquiry-form-interactions">
(function(){
  // Form validation and interactions
  const form = document.getElementById("inquiryForm")
  const successMessage = document.getElementById("successMessage")
  const errorMessage = document.getElementById("errorMessage")

  // Real-time validation
  // Update the validateField function to handle select elements
function validateField(field) {
    const value = field.value.trim()
    const fieldContainer = field.closest(".form-field")

    if (field.hasAttribute("required") && !value) {
      fieldContainer.classList.remove("valid")
      fieldContainer.classList.add("error")
      return false
    }

    if (field.type === "email" && value && !isValidEmail(value)) {
      fieldContainer.classList.remove("valid")
      fieldContainer.classList.add("error")
      return false
    }

    if (value) {
      fieldContainer.classList.add("valid")
      fieldContainer.classList.remove("error")
      return true
    }

    fieldContainer.classList.remove("valid")
    fieldContainer.classList.remove("error")
    return !field.hasAttribute("required")
  }


  function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return emailRegex.test(email)
  }

  // Add event listeners to all form fields
  const formFields = form.querySelectorAll("input, textarea, select")
  formFields.forEach((field) => {
    field.addEventListener("input", () => validateField(field))
    field.addEventListener("change", () => validateField(field)) // For select elements
    field.addEventListener("blur", () => validateField(field))
  })

  // Form submission - validate but let FormSubmit handle the actual submission
  form.addEventListener("submit", function (e) {
    let isValid = true
    const requiredFields = form.querySelectorAll("[required]")

    // Validate all required fields
    requiredFields.forEach((field) => {
      const fieldValue = field.value.trim()
      if (!fieldValue || (field.type === "email" && !isValidEmail(fieldValue))) {
        isValid = false
        const fieldContainer = field.closest(".form-field")
        fieldContainer.classList.add("error")
        fieldContainer.classList.remove("valid")
      } else {
        const fieldContainer = field.closest(".form-field")
        fieldContainer.classList.remove("error")
        fieldContainer.classList.add("valid")
      }
    })

    // Hide previous messages
    successMessage.classList.remove("show")
    errorMessage.classList.remove("show")

    if (!isValid) {
      e.preventDefault()
      setTimeout(() => {
        errorMessage.classList.add("show")
        // Scroll to first error
        const firstError = form.querySelector(".form-field.error")
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" })
        }
      }, 100)
    }
    // If valid, form submits naturally to FormSubmit
  })

  // Check for submission success on page load
  if (typeof window !== 'undefined') {
    window.addEventListener('DOMContentLoaded', function() {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.get('submitted') === 'true') {
        showSuccessPopup()
        // Clean URL
        window.history.replaceState({}, document.title, window.location.pathname)
      }
    })
  }

  function showSuccessPopup() {
    const popup = document.createElement('div')
    popup.className = 'success-popup'
    popup.innerHTML = '<div class="success-popup-content">' +
      '<div class="success-icon-large">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">' +
          '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 6L9 17l-5-5"></path>' +
        '</svg>' +
      '</div>' +
      '<h3>Inquiry Submitted Successfully!</h3>' +
      '<p>Thank you for your interest. Our export team will respond to your inquiry as soon as possible, typically within 24 hours.</p>' +
      '<p class="success-subtext">A confirmation email has been sent to your inbox.</p>' +
    '</div>'
    
    document.body.appendChild(popup)
    
    // Trigger animation
    setTimeout(function() {
      popup.classList.add('show')
    }, 100)
    
    // Auto-dismiss after 5 seconds
    setTimeout(function() {
      popup.classList.remove('show')
      setTimeout(function() {
        popup.remove()
      }, 500)
    }, 5000)
    
    // Click to dismiss
    popup.addEventListener('click', function() {
      popup.classList.remove('show')
      setTimeout(function() {
        popup.remove()
      }, 500)
    })
  }
    
  // Packaging animation trigger
(function() {
    let currentStage = 1
    const totalStages = 4
    
    const stages = document.querySelectorAll('.stage')
    const detailCards = document.querySelectorAll('.detail-card')
    const progress = document.getElementById('journeyProgress')
    const prevBtn = document.getElementById('prevStage')
    const nextBtn = document.getElementById('nextStage')
    const resetBtn = document.getElementById('resetJourney')
    
    function updateJourney(stageNum) {
      currentStage = stageNum
      
      // Update progress bar
      const progressPercent = ((currentStage - 1) / (totalStages - 1)) * 100
      progress.style.width = progressPercent + '%'
      
      // Update stages
      stages.forEach((stage, index) => {
        const stageNumber = index + 1
        if (stageNumber < currentStage) {
          stage.classList.add('completed')
          stage.classList.remove('active')
        } else if (stageNumber === currentStage) {
          stage.classList.add('active')
          stage.classList.remove('completed')
        } else {
          stage.classList.remove('active', 'completed')
        }
      })
      
      // Update detail cards
      detailCards.forEach((card, index) => {
        if (index + 1 === currentStage) {
          card.classList.add('active')
        } else {
          card.classList.remove('active')
        }
      })
      
      // Update button states
      prevBtn.disabled = currentStage === 1
      nextBtn.disabled = currentStage === totalStages
      
      if (currentStage === totalStages) {
        nextBtn.textContent = '✓ Complete'
      } else {
        nextBtn.textContent = 'Next Stage →'
      }
    }
    
    // Click on stages
    stages.forEach((stage, index) => {
      stage.addEventListener('click', () => {
        updateJourney(index + 1)
      })
    })
    
    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentStage > 1) {
          updateJourney(currentStage - 1)
        }
      })
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        if (currentStage < totalStages) {
          updateJourney(currentStage + 1)
        }
      })
    }
    
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        updateJourney(1)
      })
    }
    
    // Initialize
    updateJourney(1)
    
    // Auto-advance demo (optional - can be removed)
    let autoPlayInterval
    function startAutoPlay() {
      autoPlayInterval = setInterval(() => {
        if (currentStage < totalStages) {
          updateJourney(currentStage + 1)
        } else {
          updateJourney(1)
        }
      }, 4000)
    }
    
    // Pause auto-play on interaction
    document.querySelector('.packaging-demo').addEventListener('click', () => {
      clearInterval(autoPlayInterval)
    })
    
    // Start auto-play when section is visible
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          startAutoPlay()
        } else {
          clearInterval(autoPlayInterval)
        }
      })
    }, { threshold: 0.5 })
    
    const packagingDemo = document.getElementById('packagingDemo')
    if (packagingDemo) {
      observer.observe(packagingDemo)
    }
  })()

  // Make triggerPackaging available globally for the button
  window.triggerPackaging = triggerPackaging

  // Reset form
  form.addEventListener("reset", function () {
    const fieldContainers = form.querySelectorAll(".form-field")
    fieldContainers.forEach((container) => {
      container.classList.remove("valid")
    })

    successMessage.classList.remove("show")
    errorMessage.classList.remove("show")

    const packagingBox = document.getElementById("packagingBox")
    if (packagingBox) {
      packagingBox.classList.remove("opened")
    }
  })

  // Smooth scrolling for CTA buttons
  const ctaButtons = document.querySelectorAll(".btn")
  ctaButtons.forEach((button) => {
    if (button.textContent.includes("Request Inquiry")) {
      button.addEventListener("click", function (e) {
        if (
          this.closest(".hero-section") ||
          this.closest(".trust-cta") ||
          this.closest(".cta-card")
        ) {
          e.preventDefault()
          const formSection = document.querySelector(".inquiry-form-section")
          if (formSection) {
            formSection.scrollIntoView({ behavior: "smooth", block: "start" })
          }
        }
      })
    }
  })

  // Animation observer for sections
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const animateOnScroll = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  // Observe all sections for animations
  const sections = document.querySelectorAll("section")
  sections.forEach((section) => {
    section.style.opacity = "0"
    section.style.transform = "translateY(30px)"
    section.style.transition = "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)"
    animateOnScroll.observe(section)
  })

  // Trust card hover effects
  const trustCards = document.querySelectorAll(".trust-card")
  trustCards.forEach((card) => {
    card.addEventListener("mouseenter", function () {
      this.style.transform = "translateY(-8px) scale(1.02)"
    })

    card.addEventListener("mouseleave", function () {
      this.style.transform = "translateY(0) scale(1)"
    })
  })

  // CTA card interactions
  const ctaCards = document.querySelectorAll(".cta-card")
  ctaCards.forEach((card) => {
    card.addEventListener("mouseenter", function () {
      const button = this.querySelector(".btn")
      if (button) {
        button.style.transform = "translateY(-2px)"
      }
    })

    card.addEventListener("mouseleave", function () {
      const button = this.querySelector(".btn")
      if (button) {
        button.style.transform = "translateY(0)"
      }
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>

      <section className="hero-section2">
        <div className="hero-container">
          <div className="hero-content2">
            <div className="hero-text1">
              <h1 className="hero-title">
                Nature Ready — Curated Exports
              </h1>
              <p className="hero-subtitle">
                Sustainable, traceable, and exquisitely finished ingredients for
                premium food, wellness, and retail lines. Request a custom
                inquiry to begin your tailored export journey.
              </p>
              <div className="hero-actions">
                <p className="hero-supporting">
                  Sample-ready packaging, MOQ flexibility, export compliance
                  guaranteed.
                </p>
              </div>
              <div className="hero-microcopy">
                <span>Secure</span>
                <span> • </span>
                <span>FSSAI‑certified sourcing</span>
                <span> • </span>
                <span>Lead times on request</span>
              </div>
            </div>
            <div className="hero-image">
              <div className="hero-image-container">
                <img
                  src={require('../images/Exim.jpg')}
                  alt="An artistic arrangement of colorful spices on elegant spoons with a dark background."
                />
                <div className="hero-image-overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="packaging-section">
        <div className="packaging-container">
          <div className="packaging-content">
            <h2 className="section-title">Inside Our Export Workflow</h2>
            <p className="section-content">
              Explore our export process through an interactive journey. Click through each stage to see how we handle your order with care.
            </p>
            <div id="packagingDemo" className="packaging-demo">
              <div className="packaging-journey">
                <div className="journey-track">
                  <div id="journeyProgress" className="journey-progress"></div>
                </div>
                <div className="journey-stages">
                  <div class="stage" data-stage="1">
                    <div class="stage-circle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 6L9 17l-5-5"></path>
                      </svg>
                    </div>
                    <div class="stage-label">Inquiry Received</div>
                  </div>
                  <div class="stage" data-stage="2">
                    <div class="stage-circle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87m-1-8.13a4 4 0 0 1 0 7.75"></path>
                        </g>
                      </svg>
                    </div>
                    <div class="stage-label">Team Review</div>
                  </div>
                  <div class="stage" data-stage="3">
                    <div class="stage-circle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                          <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73zm1 .27V12"></path>
                          <path d="M3.29 7L12 12l8.71-5"></path>
                        </g>
                      </svg>
                    </div>
                    <div class="stage-label">Quality Check</div>
                  </div>
                  <div class="stage" data-stage="4">
                    <div class="stage-circle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                          <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>
                          <path d="M15 18H9m12-7v5a2 2 0 0 1-2 2h-2"></path>
                          <circle cx="12" cy="18" r="2"></circle>
                          <circle cx="18" cy="18" r="2"></circle>
                        </g>
                      </svg>
                    </div>
                    <div class="stage-label">Ready to Ship</div>
                  </div>
                </div>
              </div>
              
              <div id="stageDetails" className="stage-details">
                <div class="detail-card active" data-detail="1">
                  <h4>📬 Inquiry Received</h4>
                  <p>Your inquiry is logged in our system. We acknowledge receipt and begin processing your requirements immediately.</p>
                  <div class="detail-stats">
                    <span>⏱️ Response time: &lt;24 hours</span>
                  </div>
                </div>
                <div class="detail-card" data-detail="2">
                  <h4>👥 Team Review</h4>
                  <p>Our export specialists analyze your needs, check inventory availability, and verify compliance requirements for your destination.</p>
                  <div class="detail-stats">
                    <span>✅ 100% compliance verified</span>
                  </div>
                </div>
                <div class="detail-card" data-detail="3">
                  <h4>🔬 Quality Check</h4>
                  <p>Products undergo rigorous quality testing. Lab reports and certificates are prepared for your specific requirements.</p>
                  <div class="detail-stats">
                    <span>🏆 FSSAI certified</span>
                  </div>
                </div>
                <div class="detail-card" data-detail="4">
                  <h4>🚚 Ready to Ship</h4>
                  <p>Your order is packaged with care using sustainable materials, ready for export with all documentation complete.</p>
                  <div class="detail-stats">
                    <span>♻️ 100% recyclable packaging</span>
                  </div>
                </div>
              </div>

              <div className="packaging-controls">
                <button id="prevStage" className="btn btn-outline" disabled>
                  ← Previous
                </button>
                <button id="nextStage" className="btn btn-primary">
                  Next Stage →
                </button>
                <button id="resetJourney" className="btn btn-secondary">
                  ↺ Start Over
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="inquiry-form-section">
        <div className="inquiry-container">
          <div className="form-header1">
            <h2 className="section-title">Inquiry &amp; Custom Order</h2>
            <p className="section-subtitle">
              Tell us your requirements — our export team will respond within 24
              hours.
            </p>
          </div>
          <form 
            id="inquiryForm" 
            className="inquiry-form"
            action="https://formsubmit.co/thenatureready@gmail.com" 
            method="POST"
          >
            {/* FormSubmit Configuration - Hidden Fields */}
            <input type="hidden" name="_subject" value="New Custom Order Inquiry from Nature Ready Website" />
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_next" value={typeof window !== 'undefined' ? `${window.location.href.split('?')[0]}?submitted=true` : ""} />                    
            <div className="form-grid1">
              <div className="form-field required">
                <label htmlFor="product">Product / SKU</label>
                <input
                  type="text"
                  id="product"
                  name="Product_SKU"
                  required
                />
                <div className="field-tooltip">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4m0-4h.01"></path>
                    </g>
                  </svg>
                  <span className="tooltip-text">
                    Use SKU or product name for fastest response
                  </span>
                </div>
                <div className="success-indicator">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="form-field required">
                <label htmlFor="quantity">Quantity &amp; Packaging</label>
                <input
                  type="text"
                  id="quantity"
                  name="Quantity_and_Packaging"
                  required
                />
                <div className="field-tooltip">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4m0-4h.01"></path>
                    </g>
                  </svg>
                  <span className="tooltip-text">
                    Specify units, pack size, and preferred packaging (carton,
                    bulk, pallet)
                  </span>
                </div>

                <div className="success-indicator">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="form-field required">
                <label htmlFor="orderType">Order Request Type</label>
                <select id="orderType" name="Order_Request_Type" required>
                  <option value="">Select type...</option>
                  <option value="Bulk Order">Bulk Order</option>
                  <option value="Small Order">Small Order</option>
                  <option value="Quote Only">Quote Only</option>
                  <option value="Sample Request">Sample Request</option>
                </select>
                <div className="field-tooltip">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4m0-4h.01"></path>
                    </g>
                  </svg>
                  <span className="tooltip-text">
                    Select the type of inquiry for faster processing
                  </span>
                </div>
                <div className="success-indicator">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="form-field">
                <label htmlFor="shipDate">Preferred Ship Date</label>
                <input type="date" id="shipDate" name="Preferred_Ship_Date" />
                <div className="field-tooltip">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4m0-4h.01"></path>
                    </g>
                  </svg>
                  <span className="tooltip-text">
                    Estimated month or exact date helps confirm export schedules
                  </span>
                </div>
                <div className="success-indicator">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="form-field required">
                <label htmlFor="contactName">Contact Name</label>
                <input
                  type="text"
                  id="contactName"
                  name="Contact_Name"
                  required
                />
                <div className="field-tooltip">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4m0-4h.01"></path>
                    </g>
                  </svg>
                  <span className="tooltip-text">
                    Full name for our export documentation
                  </span>
                </div>
                <div className="success-indicator">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="form-field required">
                <label htmlFor="companyName">Company / Buyer Entity</label>
                <input
                  type="text"
                  id="companyName"
                  name="Company_Name"
                  required
                />
                <div className="field-tooltip">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4m0-4h.01"></path>
                    </g>
                  </svg>
                  <span className="tooltip-text">
                    Your business or organization name
                  </span>
                </div>
                <div className="success-indicator">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="form-field required">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="Email" required />
                <div className="field-tooltip">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4m0-4h.01"></path>
                    </g>
                  </svg>
                  <span className="tooltip-text">
                    We'll use this to send order confirmations and documents
                  </span>
                </div>
                <div className="success-indicator">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="form-field required">
                <label htmlFor="phone">Phone (with country code)</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="Phone" 
                  placeholder="+1 555-123-4567"
                  required 
                />
                <div className="field-tooltip">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4m0-4h.01"></path>
                    </g>
                  </svg>
                  <span className="tooltip-text">
                    Include country code for international calls (e.g., +44, +91, +1)
                  </span>
                </div>
                <div className="success-indicator">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="form-field required">
                <label htmlFor="destinationCountry">Destination Country</label>
                <input
                  type="text"
                  id="destinationCountry"
                  name="Destination_Country"
                  required
                />
                <div className="field-tooltip">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4m0-4h.01"></path>
                    </g>
                  </svg>
                  <span className="tooltip-text">
                    Country where goods will be shipped
                  </span>
                </div>
                <div className="success-indicator">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>

            
            <div className="form-field full-width">
              <label htmlFor="details">
                Additional details or special requests
              </label>
              <textarea id="details" name="Additional_Details" rows="4"></textarea>
              <div className="field-tooltip">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 16v-4m0-4h.01"></path>
                  </g>
                </svg>
                <span className="tooltip-text">
                  Allergens, certifications required, or custom labeling notes
                </span>
              </div>
            </div>
            <div className="privacy-notice">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 22s8-4 8-10V5l-8-3l-8 3v7c0 6 8 10 8 10"
                ></path>
              </svg>
              <p>Your data is handled with privacy and security. We never share your information with third parties.</p>
            </div>
            <div className="form-actions1">
              <button type="submit" className="btn btn-primary">
                Submit Inquiry
              </button>
              <button type="reset" className="btn btn-outline">
                Clear
              </button>
            </div>
            <div id="successMessage" className="form-message success">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M20 6L9 17l-5-5"
                ></path>
              </svg>
              <span>
                Inquiry submitted — a Nature Ready export specialist will
                contact you shortly. A confirmation email has been sent.
              </span>
            </div>
            <div id="errorMessage" className="form-message error">
              <span>
                Please complete all required fields highlighted in red.
              </span>
            </div>
          </form>
        </div>
      </section>
      <section className="trust-section">
        <div className="trust-container">
          <div className="trust-grid2">
            <div className="trust-card1">
              <div className="trust-icon1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  ></path>
                </svg>
              </div>
              <h3>Secure &amp; Quality Assured</h3>
              <p>
                We prioritize your trust with rigorous quality control, secure handling, and data privacy safeguards. 
                From farm to freight, every step is monitored for consistency, safety, and compliance with international best practices.
              </p>
              <div className="certification-badges">
                <span className="badge1">Tamper-Proof Packaging</span>
                <span className="badge1">Batch-Level Quality Checks</span>
              </div>
            </div>
            <div className="trust-card1">
              <div className="trust-icon1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                  </g>
                </svg>
              </div>
              <h3>Global Reach</h3>
              <p>
                Our products originate from trusted farms across India, prepared for global markets. 
                We follow internationally recognized standards and are equipped for export to major regions including Europe, North America, and the Middle East.
              </p>
              <div className="global-stats1">
                <div className="stat">
                  <strong>Export-Ready</strong>
                  <span>Infrastructure</span>
                </div>
                <div className="stat">
                  <strong>Trusted</strong>
                  <span>By Global Buyers</span>
                </div>
              </div>
            </div>
            <div className="trust-card1">
              <div className="trust-icon1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8c0 5.5-4.78 10-10 10"></path>
                    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
                  </g>
                </svg>
              </div>
              <h3>Sustainability Commitments</h3>
              <p>
                Regenerative farming partnerships, low-impact processing, and
                recyclable packaging. We publish measurable sustainability
                metrics: water use reduction and renewable-energy share.
              </p>
              <div className="sustainability-metrics">
                <div className="metric">
                  <strong>40%</strong>
                  <span>Water Reduction</span>
                </div>
                <div className="metric">
                  <strong>75%</strong>
                  <span>Renewable Energy</span>
                </div>
              </div>
            </div>
          </div>
          <div className="trust-cta">
            <p>
              Questions about compliance or traceability? Use Request Inquiry to
              attach your buyer specifications — our export team responds within
              one business day.
            </p>
            <button 
              className="btn btn-outline"
              onClick={(e) => {
                e.preventDefault();
                const formSection = document.querySelector(".inquiry-form-section");
                if (formSection) {
                  formSection.scrollIntoView({ behavior: "smooth", block: "start" });
                }
              }}
            >
              Request Inquiry
            </button>
          </div>
        </div>
      </section>
      <Footer></Footer>

      {/* Success Popup */}
      {showSuccess && (
        <div 
          className={`success-popup ${showSuccess ? 'show' : ''}`}
          onClick={() => setShowSuccess(false)}
        >
          <div className="success-popup-content">
            <div className="success-icon-large">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 6L9 17l-5-5"></path>
              </svg>
            </div>
            <h3>Inquiry Submitted Successfully! 🎉</h3>
            <p>Thank you for your interest. Our export team will respond to your inquiry as soon as possible, typically within 24 hours.</p>
            <p className="success-subtext">A confirmation email has been sent to your inbox.</p>
            <button 
              onClick={() => setShowSuccess(false)}
              style={{
                marginTop: '1.5rem',
                padding: '0.75rem 2rem',
                background: 'rgba(255, 255, 255, 0.2)',
                border: '2px solid white',
                borderRadius: '8px',
                color: 'white',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
              onMouseOut={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
            >
              Close
            </button>
          </div>
        </div>
        )}
    </div>
  )
}

export default InquiryCustomOrder
